// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bree+Serif&family=Lato&family=Pacifico&family=Roboto:wght@300;400&family=Rubik&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

strong {
  font-weight: bolder;
  font-size: 13px;
  text-transform: capitalize;
}

label {
  display: inline-block;
  margin-bottom: 4px;
  font-size: 14px;
}

.productItem p {
  line-height: 1.3;
  font-size: 14px;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: 'Lato', sans-serif;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

a:hover {
  text-decoration: none;
}

.tiny_size {
  font-size: 11px;
}

.small_text {
  font-size: 11px;
  text-decoration: underline;
  margin-left: 5px;
}

.bold_mak {
  font-weight: 800;
}

.loader-wrapper {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: grid;
  place-items: center;
}

.loader {
  border: 16px solid #e3e3e3;
  border-top: 16px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

.selectcategory {
  border: 1px solid #d1d3e2;
  padding: 5px;
  cursor: pointer;
  border-radius: 4px;
}

.subcategory {
  border: 1px solid #d1d3e2;
}

.subcategory li {
  cursor: pointer;
}

.subcategory ul {
  list-style: none;
}

input[type="search"],
select,
input[type="date"] {
  border: 1px solid #aaa;
  border-radius: 3px;
  padding: 5px;
  background-color: transparent;
  margin-left: 3px;
  /* margin-bottom: 10px; */
}

/* Igm on_issues Css start */
#StatusLight input[type="radio"].OPEN {
  accent-color: #ff0000;
}

#StatusLight input[type="radio"].CREATED {
  accent-color: #ff0000;
}

#StatusLight input[type="radio"].RESOLVED {
  accent-color: #00ff00;
}

#StatusLight input[type="radio"].Closed {
  accent-color: #00ff00;
}

#StatusLight input[type="radio"].PROCESSING {
  accent-color: #ffcc00;
}

::-webkit-scrollbar {
  width: 5px;
}

.btn-circle {
  /* height: 1.5rem !important;/ */
}

.tableAlignment tr th {
  text-align: start;
}

.tableAlignment tr td {
  text-align: start;
}

.ant-modal-content {
  overflow-y: scroll;
  /* height: 33 vh; */
  /* bottom: 24vh; */

}



.top .ant-modal-content {
  bottom: 0;
  display: flex;
  justify-content: center;
}

.no-blur-modal .ant-modal-content {
  -webkit-backdrop-filter: none !important;
          backdrop-filter: none !important;
  box-shadow: none !important;
}

.custom-left-modal .ant-modal {
  left: 10;
  margin: 0;
  transform: none !important;
}


.btn {
  line-height: 1.2 !important;
}

::-webkit-scrollbar-track {
  width: 5px;
  /* background: #f5f5f5; */
}

::-webkit-scrollbar-thumb {
  width: 1em;
  background-color: #ddd;
  /* outline: 1px solid slategrey; */
  border-radius: 1rem;
}

.text-small {
  font-size: 0.9rem;
}

/* Igm on_issues Css End */

.genericlabel {
  font-size: 14px;
  font-weight: 600;
  color: black;
}

.commonBtn {
  background-color: #001ad5;
  /* color: black; */
  padding: 11px 16px;
  font-weight: 600;
  font-size: 14px;
  color: white;
  border-radius: 23px;

}

.multiOrderStatusSelector {
  width: 400px;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* category And SubCategory Css */

.makeCategory_subCategory .category_list {
  margin-left: 20px;
  max-height: 300px;
  overflow: scroll;
}

.makeCategory_subCategory ul {
  list-style: none;
  /* padding-left: 20px; */
  max-height: 300px;
  overflow-y: scroll;
}

.makeCategory_subCategory ul li {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.makeCategory_subCategory ul li span {
  margin-right: 5px;
  cursor: pointer;
}

.makeCategory_subCategory ul li input[type="checkbox"] {
  margin-right: 5px;
}

.makeCategory_subCategory ul ul {
  padding-left: 20px;
}

.makeCategory_subCategory ul ul li {
  margin-bottom: 3px;
}

.makeCategory_subCategory input[type="checkbox"]:checked+span::before {
  content: '-';
}

.makeCategory_subCategory input[type="checkbox"]:not(:checked)+span::before {
  content: '+';
}


.makeCategory_subCategory ul li {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.makeCategory_subCategory ul li span {
  margin-right: 5px;
  cursor: pointer;
  color: #333;
}

.makeCategory_subCategory ul li input[type="checkbox"] {
  margin-right: 5px;
}

.makeCategory_subCategory ul ul {
  padding-left: 20px;
}

.makeCategory_subCategory ul ul li {
  margin-bottom: 3px;
}

.makeCategory_subCategory ul li input[type="checkbox"]:checked+span::before {
  content: '-';
}

.makeCategory_subCategory ul li input[type="checkbox"]:not(:checked)+span::before {
  content: '+';
}




/*Login Css  */
.main_container {
  width: 65% !important;
}

.main_container .image_wrapper .imagesSetup {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.login_btn {
  background: #11335b;
}

.main_container .image_wrapper .image1 img {
  border-bottom-left-radius: 15px;
  border-top-left-radius: 15px;
}

.main_container .loginFormat .form_padding {
  padding-inline-start: 30px !important;
}

::placeholder {
  padding-left: 10px;
}

.loginFormat .Icons {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translate(-50%, -50%);
  line-height: 1;
  color: #000000;
}

.showdiv {
  display: block;
}

.hidediv {
  display: none;
}

.customModal {
  position: absolute;
  top: 30%;
  left: 50%;
  background: red;
  width: 400px;
  height: 400px;
  transform: translate(-50%, -50%);
}

@media(max-width: 1024px) {
  .multiOrderStatusSelector {
    width: 320px !important;
  }
}



@media(max-width: 767px) {
  .main_container {
    width: 100% !important;
  }

  .image_wrapper .image1 {
    margin-top: 40px;
  }

  .image_wrapper .image1 img {
    border-radius: 10px;
  }

  #padding {
    padding: 0 !important;
  }

  .flex_direction {
    flex-direction: row;
  }

  .showdiv {
    display: none;
  }

  .hidediv {
    display: block;
  }



}

@media(min-width: 768px) and (max-width: 1024px) {
  .main_container {
    width: 100% !important;
  }



}

.allservice_btn {
  position: absolute;
  width: -moz-fit-content;
  width: fit-content;
  right: 0px;
  background: #fff;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-radius: 8px;
}

@media(max-width: 490px) {
  .multiOrderStatusSelector {
    width: 305px !important;
  }
}

/* .allservice_btn {
  display: none;
}

.all-service-btn:hover .allservice_btn {
  display: flex;
} */

/* Overlay */
.overlay_modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgb(50 47 47 / 60%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;

}


/* Modal Box */
.custom_modal {
  position: relative;
  background: #fff;
  padding: 20px;
  width: -moz-fit-content;
  width: fit-content;
  max-width: 90%;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}


/* Modal Animation */
@keyframes popup {
  from {
    transform: scale(0.7);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}

/* Close Button */
.crossIcon {
  position: absolute;
  right: 12px;
  top: 12px;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
}

@keyframes growIn {
  0% {
    transform: translateY(-120px);
    opacity: 0;
  }

  60% {
    transform: translateY(20px);
    opacity: 1;
  }

  80% {
    transform: translateY(-10px);
  }

  100% {
    transform: translateY(0);
  }
}


/* step css  */

.progress-circle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 2px solid #ccc;
  background: #fff;
  color: #999;
  transition: all 0.3s ease;
}

.progress-circle.active {
  border-color: #ff6a00;
  color: #ff6a00;
}

.progress-circle.completed {
  background-color: #ff6a00;
  border-color: #ff6a00;
  color: #fff;
}

.inner-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.bg-orange {
  background-color: #ff6a00;
}

.connector-line {
  width: 90px;
  border-top: 2px dashed #ccc;
}

.connector-line.completed-line {
  border-color: #ff6a00;
}

input[type="file"]::file-selector-button {
  background: #f1f1f1;
  border: none;
  padding: 6px 12px;
  margin-right: 10px;
  border-radius: 6px;
  cursor: pointer;
}

input[type="file"]::file-selector-button:hover {
  background: #e2e2e2;
}

.form-control:focus,
.form-select:focus {
  border-color: #ff6a00;
  box-shadow: 0 0 0 0.2rem rgba(255, 106, 0, 0.25);
}

.form-control:focus {
  border-color: #ff6a00;
  box-shadow: 0 0 0 0.2rem rgba(255, 106, 0, 0.25);
}

.form-control:focus {
  border-color: #ff6a00;
  box-shadow: 0 0 0 0.2rem rgba(255, 106, 0, 0.25);
}

.agreement-container {
  width: 100%;
  margin: 20px auto;
  font-family: Arial, sans-serif;
}

.agreement-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.agreement-box {
  background-color: #f3ebe5;
  padding: 18px;
  border-radius: 6px;
}

.checkbox-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  font-size: 14px;
  cursor: pointer;
}

.checkbox-row input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #ff7a00;
  /* orange like image */
  cursor: pointer;
}

.link {
  color: #ff7a00;
  text-decoration: none;
  font-weight: 500;
}

.link:hover {
  text-decoration: underline;
}


/* modal css  */

/* Overlay */
.custom-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* Modal box */
.custom-modal {
  background: #fff;
  width: 420px;
  border-radius: 16px;
  padding: 30px 25px;
  text-align: center;
  animation: scaleIn 0.3s ease;
}

.headerLogin {
  border: 1px solid linear-gradient(90deg, #F75710 -51.11%, #FC8809 48.89%);
  outline: none;
  border: none;
  border-radius: 10px;
  color: #fff;
  background: #fff;
  color: #F75710;
}

/* Animation */
@keyframes scaleIn {
  from {
    transform: scale(0.8);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}

/* Success Icon */
.success-icon {
  width: 70px;
  height: 70px;
  background: #d1fae5;
  color: #16a34a;
  font-size: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 15px;
}

/* Title */
.title {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 8px;
}

input[type="radio"] {
  appearance: none !important;
  width: 16px !important;
  height: 16px !important;
  border: 2px solid #999 !important;
  border-radius: 50% !important;
  position: relative !important;
}

input[type="file"] {
  height: auto !important;
}

input[type="radio"]:checked {
  border-color: orange !important;
}

input[type="radio"]:checked::before {
  content: "";
  width: 8px;
  height: 8px;
  background: linear-gradient(90deg, #F75710 -51.11%, #FC8809 48.89%);
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 2px;
}

/* Subtitle */
.subtitle {
  color: #000;
  font-size: 14px;
  margin-bottom: 20px;
}

/* Steps */
.steps {
  text-align: left;
  margin-bottom: 20px;
}

.step {
  display: flex;
  gap: 10px;
  margin-bottom: 12px;
  font-size: 14px;
}

.step .icon {
  font-size: 16px;
}

/* Buttons */

.actions {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.actions button {
  outline: none;
  border: none;
  padding: 8px 16px;
  border-radius: 10px;
  background: #f97316;
  color: #fff;
}

.btn {
  flex: 1 1;
  padding: 10px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
}

.btn.primary {
  background: #f97316;
  color: white;
  border: none;
}

.btn.outline {
  border: 1px solid #f97316;
  color: #f97316;
  background: white;
}

/* end css  */`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAGA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;;AAEpB;;;;AAIA;EACE,SAAS;EACT,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,wCAAgC;UAAhC,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,0BAA0B;AAC5B;;;AAGA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,0BAA0B;;AAE1B;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,mBAAmB;;AAErB;;AAEA;EACE,YAAY;AACd;;AAEA,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,iCAAiC;;AAEjC;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;;;;AAKA,cAAc;AACd;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,gCAAgC;EAChC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,YAAY;EACZ,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;;;AAIA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;;;AAIF;;AAEA;EACE;IACE,sBAAsB;EACxB;;;;AAIF;;AAEA;EACE,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;;;;;;GAMG;;AAEH,YAAY;AACZ;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;;AAEd;;;AAGA,cAAc;AACd;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAkB;EAAlB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,yCAAyC;AAC3C;;;AAGA,oBAAoB;AACpB;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE;IACE,6BAA6B;IAC7B,UAAU;EACZ;;EAEA;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;;AAGA,cAAc;;AAEd;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA,eAAe;;AAEf,YAAY;AACZ;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,yEAAyE;EACzE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EACvB,iCAAiC;EACjC,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,mEAAmE;EACnE,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA,aAAa;AACb;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,YAAY;;AAEZ;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA,aAAa","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Bree+Serif&family=Lato&family=Pacifico&family=Roboto:wght@300;400&family=Rubik&display=swap');\n\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nstrong {\n  font-weight: bolder;\n  font-size: 13px;\n  text-transform: capitalize;\n}\n\nlabel {\n  display: inline-block;\n  margin-bottom: 4px;\n  font-size: 14px;\n}\n\n.productItem p {\n  line-height: 1.3;\n  font-size: 14px;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-family: 'Lato', sans-serif;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\na:hover {\n  text-decoration: none;\n}\n\n.tiny_size {\n  font-size: 11px;\n}\n\n.small_text {\n  font-size: 11px;\n  text-decoration: underline;\n  margin-left: 5px;\n}\n\n.bold_mak {\n  font-weight: 800;\n}\n\n.loader-wrapper {\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  display: grid;\n  place-items: center;\n}\n\n.loader {\n  border: 16px solid #e3e3e3;\n  border-top: 16px solid #3498db;\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  animation: spin 1s linear infinite;\n}\n\n.selectcategory {\n  border: 1px solid #d1d3e2;\n  padding: 5px;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.subcategory {\n  border: 1px solid #d1d3e2;\n}\n\n.subcategory li {\n  cursor: pointer;\n}\n\n.subcategory ul {\n  list-style: none;\n}\n\ninput[type=\"search\"],\nselect,\ninput[type=\"date\"] {\n  border: 1px solid #aaa;\n  border-radius: 3px;\n  padding: 5px;\n  background-color: transparent;\n  margin-left: 3px;\n  /* margin-bottom: 10px; */\n}\n\n/* Igm on_issues Css start */\n#StatusLight input[type=\"radio\"].OPEN {\n  accent-color: #ff0000;\n}\n\n#StatusLight input[type=\"radio\"].CREATED {\n  accent-color: #ff0000;\n}\n\n#StatusLight input[type=\"radio\"].RESOLVED {\n  accent-color: #00ff00;\n}\n\n#StatusLight input[type=\"radio\"].Closed {\n  accent-color: #00ff00;\n}\n\n#StatusLight input[type=\"radio\"].PROCESSING {\n  accent-color: #ffcc00;\n}\n\n::-webkit-scrollbar {\n  width: 5px;\n}\n\n.btn-circle {\n  /* height: 1.5rem !important;/ */\n}\n\n.tableAlignment tr th {\n  text-align: start;\n}\n\n.tableAlignment tr td {\n  text-align: start;\n}\n\n.ant-modal-content {\n  overflow-y: scroll;\n  /* height: 33 vh; */\n  /* bottom: 24vh; */\n\n}\n\n\n\n.top .ant-modal-content {\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n}\n\n.no-blur-modal .ant-modal-content {\n  backdrop-filter: none !important;\n  box-shadow: none !important;\n}\n\n.custom-left-modal .ant-modal {\n  left: 10;\n  margin: 0;\n  transform: none !important;\n}\n\n\n.btn {\n  line-height: 1.2 !important;\n}\n\n::-webkit-scrollbar-track {\n  width: 5px;\n  /* background: #f5f5f5; */\n}\n\n::-webkit-scrollbar-thumb {\n  width: 1em;\n  background-color: #ddd;\n  /* outline: 1px solid slategrey; */\n  border-radius: 1rem;\n}\n\n.text-small {\n  font-size: 0.9rem;\n}\n\n/* Igm on_issues Css End */\n\n.genericlabel {\n  font-size: 14px;\n  font-weight: 600;\n  color: black;\n}\n\n.commonBtn {\n  background-color: #001ad5;\n  /* color: black; */\n  padding: 11px 16px;\n  font-weight: 600;\n  font-size: 14px;\n  color: white;\n  border-radius: 23px;\n\n}\n\n.multiOrderStatusSelector {\n  width: 400px;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* category And SubCategory Css */\n\n.makeCategory_subCategory .category_list {\n  margin-left: 20px;\n  max-height: 300px;\n  overflow: scroll;\n}\n\n.makeCategory_subCategory ul {\n  list-style: none;\n  /* padding-left: 20px; */\n  max-height: 300px;\n  overflow-y: scroll;\n}\n\n.makeCategory_subCategory ul li {\n  display: flex;\n  align-items: center;\n  margin-bottom: 5px;\n}\n\n.makeCategory_subCategory ul li span {\n  margin-right: 5px;\n  cursor: pointer;\n}\n\n.makeCategory_subCategory ul li input[type=\"checkbox\"] {\n  margin-right: 5px;\n}\n\n.makeCategory_subCategory ul ul {\n  padding-left: 20px;\n}\n\n.makeCategory_subCategory ul ul li {\n  margin-bottom: 3px;\n}\n\n.makeCategory_subCategory input[type=\"checkbox\"]:checked+span::before {\n  content: '-';\n}\n\n.makeCategory_subCategory input[type=\"checkbox\"]:not(:checked)+span::before {\n  content: '+';\n}\n\n\n.makeCategory_subCategory ul li {\n  display: flex;\n  align-items: center;\n  margin-bottom: 5px;\n}\n\n.makeCategory_subCategory ul li span {\n  margin-right: 5px;\n  cursor: pointer;\n  color: #333;\n}\n\n.makeCategory_subCategory ul li input[type=\"checkbox\"] {\n  margin-right: 5px;\n}\n\n.makeCategory_subCategory ul ul {\n  padding-left: 20px;\n}\n\n.makeCategory_subCategory ul ul li {\n  margin-bottom: 3px;\n}\n\n.makeCategory_subCategory ul li input[type=\"checkbox\"]:checked+span::before {\n  content: '-';\n}\n\n.makeCategory_subCategory ul li input[type=\"checkbox\"]:not(:checked)+span::before {\n  content: '+';\n}\n\n\n\n\n/*Login Css  */\n.main_container {\n  width: 65% !important;\n}\n\n.main_container .image_wrapper .imagesSetup {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.login_btn {\n  background: #11335b;\n}\n\n.main_container .image_wrapper .image1 img {\n  border-bottom-left-radius: 15px;\n  border-top-left-radius: 15px;\n}\n\n.main_container .loginFormat .form_padding {\n  padding-inline-start: 30px !important;\n}\n\n::placeholder {\n  padding-left: 10px;\n}\n\n.loginFormat .Icons {\n  position: absolute;\n  left: 15px;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  line-height: 1;\n  color: #000000;\n}\n\n.showdiv {\n  display: block;\n}\n\n.hidediv {\n  display: none;\n}\n\n.customModal {\n  position: absolute;\n  top: 30%;\n  left: 50%;\n  background: red;\n  width: 400px;\n  height: 400px;\n  transform: translate(-50%, -50%);\n}\n\n@media(max-width: 1024px) {\n  .multiOrderStatusSelector {\n    width: 320px !important;\n  }\n}\n\n\n\n@media(max-width: 767px) {\n  .main_container {\n    width: 100% !important;\n  }\n\n  .image_wrapper .image1 {\n    margin-top: 40px;\n  }\n\n  .image_wrapper .image1 img {\n    border-radius: 10px;\n  }\n\n  #padding {\n    padding: 0 !important;\n  }\n\n  .flex_direction {\n    flex-direction: row;\n  }\n\n  .showdiv {\n    display: none;\n  }\n\n  .hidediv {\n    display: block;\n  }\n\n\n\n}\n\n@media(min-width: 768px) and (max-width: 1024px) {\n  .main_container {\n    width: 100% !important;\n  }\n\n\n\n}\n\n.allservice_btn {\n  position: absolute;\n  width: fit-content;\n  right: 0px;\n  background: #fff;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  border-radius: 8px;\n}\n\n@media(max-width: 490px) {\n  .multiOrderStatusSelector {\n    width: 305px !important;\n  }\n}\n\n/* .allservice_btn {\n  display: none;\n}\n\n.all-service-btn:hover .allservice_btn {\n  display: flex;\n} */\n\n/* Overlay */\n.overlay_modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  background: rgb(50 47 47 / 60%);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n\n}\n\n\n/* Modal Box */\n.custom_modal {\n  position: relative;\n  background: #fff;\n  padding: 20px;\n  width: fit-content;\n  max-width: 90%;\n  border-radius: 10px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n}\n\n\n/* Modal Animation */\n@keyframes popup {\n  from {\n    transform: scale(0.7);\n    opacity: 0;\n  }\n\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n/* Close Button */\n.crossIcon {\n  position: absolute;\n  right: 12px;\n  top: 12px;\n  font-size: 20px;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n@keyframes growIn {\n  0% {\n    transform: translateY(-120px);\n    opacity: 0;\n  }\n\n  60% {\n    transform: translateY(20px);\n    opacity: 1;\n  }\n\n  80% {\n    transform: translateY(-10px);\n  }\n\n  100% {\n    transform: translateY(0);\n  }\n}\n\n\n/* step css  */\n\n.progress-circle {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 2px solid #ccc;\n  background: #fff;\n  color: #999;\n  transition: all 0.3s ease;\n}\n\n.progress-circle.active {\n  border-color: #ff6a00;\n  color: #ff6a00;\n}\n\n.progress-circle.completed {\n  background-color: #ff6a00;\n  border-color: #ff6a00;\n  color: #fff;\n}\n\n.inner-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n}\n\n.bg-orange {\n  background-color: #ff6a00;\n}\n\n.connector-line {\n  width: 90px;\n  border-top: 2px dashed #ccc;\n}\n\n.connector-line.completed-line {\n  border-color: #ff6a00;\n}\n\ninput[type=\"file\"]::file-selector-button {\n  background: #f1f1f1;\n  border: none;\n  padding: 6px 12px;\n  margin-right: 10px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\ninput[type=\"file\"]::file-selector-button:hover {\n  background: #e2e2e2;\n}\n\n.form-control:focus,\n.form-select:focus {\n  border-color: #ff6a00;\n  box-shadow: 0 0 0 0.2rem rgba(255, 106, 0, 0.25);\n}\n\n.form-control:focus {\n  border-color: #ff6a00;\n  box-shadow: 0 0 0 0.2rem rgba(255, 106, 0, 0.25);\n}\n\n.form-control:focus {\n  border-color: #ff6a00;\n  box-shadow: 0 0 0 0.2rem rgba(255, 106, 0, 0.25);\n}\n\n.agreement-container {\n  width: 100%;\n  margin: 20px auto;\n  font-family: Arial, sans-serif;\n}\n\n.agreement-title {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.agreement-box {\n  background-color: #f3ebe5;\n  padding: 18px;\n  border-radius: 6px;\n}\n\n.checkbox-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.checkbox-row input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: #ff7a00;\n  /* orange like image */\n  cursor: pointer;\n}\n\n.link {\n  color: #ff7a00;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.link:hover {\n  text-decoration: underline;\n}\n\n\n/* modal css  */\n\n/* Overlay */\n.custom-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n/* Modal box */\n.custom-modal {\n  background: #fff;\n  width: 420px;\n  border-radius: 16px;\n  padding: 30px 25px;\n  text-align: center;\n  animation: scaleIn 0.3s ease;\n}\n\n.headerLogin {\n  border: 1px solid linear-gradient(90deg, #F75710 -51.11%, #FC8809 48.89%);\n  outline: none;\n  border: none;\n  border-radius: 10px;\n  color: #fff;\n  background: #fff;\n  color: #F75710;\n}\n\n/* Animation */\n@keyframes scaleIn {\n  from {\n    transform: scale(0.8);\n    opacity: 0;\n  }\n\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n/* Success Icon */\n.success-icon {\n  width: 70px;\n  height: 70px;\n  background: #d1fae5;\n  color: #16a34a;\n  font-size: 30px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 15px;\n}\n\n/* Title */\n.title {\n  font-size: 22px;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\ninput[type=\"radio\"] {\n  appearance: none !important;\n  width: 16px !important;\n  height: 16px !important;\n  border: 2px solid #999 !important;\n  border-radius: 50% !important;\n  position: relative !important;\n}\n\ninput[type=\"file\"] {\n  height: auto !important;\n}\n\ninput[type=\"radio\"]:checked {\n  border-color: orange !important;\n}\n\ninput[type=\"radio\"]:checked::before {\n  content: \"\";\n  width: 8px;\n  height: 8px;\n  background: linear-gradient(90deg, #F75710 -51.11%, #FC8809 48.89%);\n  border-radius: 50%;\n  position: absolute;\n  top: 2px;\n  left: 2px;\n}\n\n/* Subtitle */\n.subtitle {\n  color: #000;\n  font-size: 14px;\n  margin-bottom: 20px;\n}\n\n/* Steps */\n.steps {\n  text-align: left;\n  margin-bottom: 20px;\n}\n\n.step {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 12px;\n  font-size: 14px;\n}\n\n.step .icon {\n  font-size: 16px;\n}\n\n/* Buttons */\n\n.actions {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.actions button {\n  outline: none;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 10px;\n  background: #f97316;\n  color: #fff;\n}\n\n.btn {\n  flex: 1;\n  padding: 10px;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.btn.primary {\n  background: #f97316;\n  color: white;\n  border: none;\n}\n\n.btn.outline {\n  border: 1px solid #f97316;\n  color: #f97316;\n  background: white;\n}\n\n/* end css  */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
